<template>
  <div :style="{ width }">
    <ValidationProvider v-slot="{ errors }" :rules="rules" :name="label" :vid="name">
      <v-select
        class="select-all-field"
        v-model="localValue"
        :items="options"
        :multiple="multiple"
        placeholder="---"
        filled
        single-line
        :name="name"
        :error-messages="errors[0]"
        @input="checkLimit"
        :readonly="readonly"
        no-data-text="なし"
      >
        <template v-slot:prepend-item>
          <v-list-item ripple @click="toggle">
            <v-list-item-action>
              <v-icon :color="localValue.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{allText}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-2"></v-divider>
        </template>
      </v-select>
    </ValidationProvider>
  </div>
</template>

<script>
export default {
  props: {
    value: {},
    options: {
      type: Array,
      required: true
    },
    textKey: {
      type: String,
      default: "name"
    },
    valueKey: {
      type: String,
      default: "code"
    },
    multiple: {
      type: Boolean,
      default: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    rules: {
      type: String
    },
    label: {
      type: String
    },
    name: {
      type: String
    },
    limit: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: null
    },
    allText: {
      type: String,
      default: "すべて"
    },
    width: {
      type: String,
      default: "400px"
    }
  },
  beforeMount() {
    if (this.defaultValue) {
      this.localValue = this.defaultValue;
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value || [];
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    allValues() {
      return this.localValue.length === this.options.length;
    },
    someValue() {
      return this.localValue.length > 0 && !this.allValues;
    },
    icon() {
      if (this.allValues) return "check_box";
      if (this.someValue) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    checkLimit(selections) {
      if (this.multiple && this.limit > 1 && selections.length > this.limit) {
        selections.splice(this.limit);
      }
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allValues) {
          this.localValue = [];
        } else {
          this.localValue = (this.options || []).map(v => v.value);
        }
      });
    }
  }
};
</script>

<style module lang="scss"></style>
<style lang="scss">
.v-list__tile {
  font-size: 13px !important;
}
</style>
